import { isArray } from 'lodash';
import moment from 'moment';
import { actionCreator } from 'utils';
import * as OrderItemTypes from '../types/orderItemTypes';

const prevMonth = moment().subtract(3, 'months');
const startDate = prevMonth.format('YYYY-MM-DD 00:00:00');
const nowDate = moment().format('YYYY-MM-DD 23:59:59');

const initState = {
    loading: false,
    error: false,
    listing: null,
    submitting: false,
    offset: 0,
    limit: 50,
    showToggleStatusConfirmationPopup: false,
    showPutBulkInProductionConfirmationPopup: false,
    isPuttingBulkInProduction: false,
    sort: {
        key: 'created_at',
        type: 'desc',
    },

    checked: [],

    comment: {
        loading: false,
        error: false,
        success: false,
    },

    filters: {
        printingOffice: undefined,
        order_item_number: '',
        order_number: '',
        source: undefined,
        productGroup: [],
        companyName: [],
        specifications: [],
        quantity: '',
        state: 'WAITING_FOR_MANUFACTURING',
        transferred: undefined,
        created_at: [startDate, nowDate],
        expected_shipping_date: undefined,
        shippingMethod: [],
    },

    configurations: {
        loading: false,
        error: false,
        listing: null,
    },

    productGroups: {
        loading: false,
        error: false,
        listing: null,
    },

    neededData: {
        users: [],
        configurations: [],
        productGroups: [],
        customers: [],
        shippings: [],
    },

    view: {
        loading: true,
        error: false,
        data: null,
        percentage: 0,
        reprint: {
            loading: true,
            data: null,
        },
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case OrderItemTypes.LOAD_ORDER_ITEMS:
        return Object.assign({}, state, {
            ...state,
            loading: true,
        });

    case actionCreator(OrderItemTypes.LOAD_ORDER_ITEMS, 'err'):
        return Object.assign({}, state, {
            ...state,
            showToggleStatusConfirmationPopup: false,
            showPutBulkInProductionConfirmationPopup: false,
            isPuttingBulkInProduction: false,
            loading: false,
            error: true,
        });

    case actionCreator(OrderItemTypes.LOAD_ORDER_ITEMS, 'res'):
        return Object.assign({}, state, {
            ...state,
            showToggleStatusConfirmationPopup: false,
            showPutBulkInProductionConfirmationPopup: false,
            isPuttingBulkInProduction: false,
            loading: false,
            listing: action.data,
        });

    case OrderItemTypes.SET_ORDER_ITEM_NEEDED_DATA:
        return Object.assign({}, state, {
            ...state,
            neededData: action.data,
        });

    case OrderItemTypes.SET_ORDER_ITEM_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case OrderItemTypes.SET_ORDER_ITEM_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(OrderItemTypes.SET_ORDER_ITEM_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case OrderItemTypes.RESET_ORDER_ITEM_FILTERS:
        return Object.assign({}, state, {
            ...state,
            filters: initState.filters,
        });

    case OrderItemTypes.SHOW_TOGGLE_STATUS_CONFIRMATION_POPUP:
        return Object.assign({}, state, {
            ...state,
            showToggleStatusConfirmationPopup: true,
        });

    case OrderItemTypes.HIDE_TOGGLE_STATUS_CONFIRMATION_POPUP:
        return Object.assign({}, state, {
            ...state,
            showToggleStatusConfirmationPopup: false,
        });

    case OrderItemTypes.SHOW_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP:
        return Object.assign({}, state, {
            ...state,
            showPutBulkInProductionConfirmationPopup: true,
        });

    case OrderItemTypes.HIDE_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP:
        return Object.assign({}, state, {
            ...state,
            showPutBulkInProductionConfirmationPopup: false,
        });

    case OrderItemTypes.SET_CHECKED_ORDER_ITEMS_PRODUCTION:
        if (state.checked.includes(action.id)) {
            return Object.assign({}, state, {
                ...state,
                checked: [
                    ...state.checked.filter(c => c !== action.id),
                ],
            });
        }

        if (isArray(action.id)) {
            return Object.assign({}, state, {
                ...state,
                checked: action.id.length !== 0 ? action.id : [],
            });
        }

        return Object.assign({}, state, {
            ...state,
            checked: [
                ...state.checked.filter(c => c !== action.id),
                action.id,
            ],
        });

    case OrderItemTypes.SET_ORDER_ITEM_COMMENT:
        return Object.assign({}, state, {
            ...state,
            comment: {
                loading: true,
                error: false,
                success: false,
            },
        });

    case actionCreator(OrderItemTypes.SET_ORDER_ITEM_COMMENT, 'res'):
        return Object.assign({}, state, {
            ...state,
            comment: {
                loading: action.loading,
                success: true,
                error: false,
            },
        });

    case actionCreator(OrderItemTypes.SET_ORDER_ITEM_COMMENT, 'err'):
        return Object.assign({}, state, {
            ...state,
            comment: {
                ...state.comment,
                error: true,
                loading: false,
            },
        });

    case OrderItemTypes.PUT_BULK_IN_PRODUCTION:
        return Object.assign({}, state, {
            ...state,
            isPuttingBulkInProduction: true,
        });

    case OrderItemTypes.LOAD_ORDER_ITEM:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                loading: true,
                error: false,
            },
        });

    case actionCreator(OrderItemTypes.LOAD_ORDER_ITEM, 'res'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                loading: false,
                data: action.data,
            },
        });

    case actionCreator(OrderItemTypes.LOAD_ORDER_ITEM, 'err'):
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                loading: false,
                error: true,
            },
        });

    case OrderItemTypes.EMPTY_ORDER_ITEM:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                data: null,
                loading: true,
                error: false,
                percentage: 0,
                reprint: {
                    ...state.view.reprint,
                    loading: false,
                    data: null,
                },
            },
        });

    case OrderItemTypes.SET_ORDER_ITEM_PERCENTAGE:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                percentage: state.view.percentage + action.fragment,
            },
        });

    case OrderItemTypes.SET_REPRINT_LOADING:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                reprint: {
                    ...state.view.reprint,
                    loading: action.loading,
                },
            },
        });

    case OrderItemTypes.SET_REPRINT_DATA:
        return Object.assign({}, state, {
            ...state,
            view: {
                ...state.view,
                reprint: {
                    ...state.view.reprint,
                    data: action.data,
                },
            },
        });

    default:
        return state;
    }
}
